const o = (e) => {
  const t = new Blob([e], { type: "video/mp4" });
  return URL.createObjectURL(t);
};
export {
  o as getFileBlob
};
//# sourceMappingURL=fileUtil.mjs.map
